
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36 22"}, attrs),
              ...rest,
            },
            children.concat([_c('polygon',{staticStyle:{"fill":"#1c0f0c"},attrs:{"points":"26.05 1.61 24.62 3.01 31.92 10.5 0.85 10.5 0.85 12.5 31.92 12.5 24.62 19.99 26.05 21.39 35.69 11.5 26.05 1.61"}})])
          )
        }
      }
    